import http from '../http'

/**
 * 收藏列表
 * @param params
 * @returns {*}
 */
export function queryCollectionListSrv (params) {
  let url = '/customerAuth/queryCollectionList';
  return http.post(url, params)
}

/**
 * 取消收藏
 * @param params
 * @returns {*}
 */
export function cancelCollectionListSrv (params) {
  let url = '/customerAuth/cancelCollection';
  return http.post(url, params)
}

/**
 * 产品详情-确认收藏
 * @param params
 * @returns {*}
 */
export function collectionSrv (params) {
  let url = '/customerAuth/createCollection';
  return http.post(url, params)
}



// WEBPACK FOOTER //
// ./src/api/collect/index.js